import EventEmitter from "wolfy87-eventemitter";

class EE {
  static _instance = null;

  static getInstance() {
    if (EE._instance === null) {
      EE._instance = new EventEmitter();
    }

    return EE._instance;
  }
}

export default EE;



// WEBPACK FOOTER //
// ./src/services/event-emitter.js